
import React from 'react'
import PropTypes from 'prop-types'
import { Close } from '@mui/icons-material'
import { SPACING } from 'shared/constants/AppEnums'
import { HeaderSeparator } from 'shared/components/Header'
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Stack } from '@mui/material'

export const DialogInformation = ({ open, handleClose, header, children, title, size, style = {}, contentStyle = {} }) => {
    return (
        <Dialog fullWidth open={open} maxWidth={size} onClose={handleClose}>
            {
                header ? header : (
                    <DialogTitle sx={{ px: 0, py: SPACING / 2, ...style }}>
                        <Stack position={'relative'}>
                            <HeaderSeparator title={title} />
                            <Box position={'absolute'} top={0} bottom={0} right={0}>
                                <IconButton onClick={handleClose}>
                                    <Close />
                                </IconButton>
                            </Box>
                        </Stack>
                    </DialogTitle>
                )
            }

            <DialogContent sx={{ padding: '0 !important' }}>
                <Stack p={SPACING} sx={{ ...contentStyle }}>
                    {children}
                </Stack>
            </DialogContent>
        </Dialog>
    )
}

DialogInformation.propTypes = {
    size: PropTypes.string,
    title: PropTypes.any,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    children: PropTypes.any,
    header: PropTypes.node,
    style: PropTypes.object,
    contentStyle: PropTypes.object,
}